import axios from "axios";
import { useEffect, useState } from "react";
import { BookingSeason, NO_AVAILABLE_SEASON, NoAvailableSeason, UNKNOWN_ERROR, UnknownError } from "./interface";

export type CurrentBookingSeason = BookingSeason | NoAvailableSeason | UnknownError | undefined;

/**
 * Fetches the current booking season. Returns undefined while loading.
 */
const useCurrentBookingSeason = (): CurrentBookingSeason => {
  const [season, setSeason] = useState<CurrentBookingSeason>();

  useEffect(() => {
    axios
      .get<BookingSeason>("/booking-seasons/current/")
      .then(response => {
        setSeason(response.data);
      })
      .catch(e => {
        if (e.response?.status === 404) setSeason(NO_AVAILABLE_SEASON);
        else setSeason(UNKNOWN_ERROR);
      });
  }, []);

  return season;
};

export const isBookingSeason = (season: CurrentBookingSeason): season is BookingSeason => typeof season === "object";

export default useCurrentBookingSeason;
